export const NavigationHelper = (event, from, navigate) => {
    const urlEventName = event?.name?.split(" ").join("+");
    if (from === "result") {
        navigate(`/results/${urlEventName}?id=${event?._id}`, { state: { event: event, from: from }, })
        return
    }
    event?.eventType === "Grade Exam" && navigate(`/grade/${urlEventName}?id=${event?._id}`, { state: { event: event, from: from }, });
    event?.eventType === "Feiseanna" && navigate(`/feis/${urlEventName}?id=${event?._id}`, { state: { event: event, from: from }, });
}
